import { EntityType, TableName } from './entities.model';

// tslint:disable: variable-name

export interface TableOptions {
  int?: string[];
  date?: string[];
}

export class DefaultTable<T = any> {

  constructor(o?: Partial<T>, config?: TableOptions) {
    if (!config) { config = { int: [], date: [] }; }
    if (o) {
      Object.assign(this, o);
      if (config.int) {
        config.int.forEach(f => {
          if (this[f]) { this[f] = parseInt(this[f]); }
        });
      }

    }
  }
}

export class TablePattern extends DefaultTable {
  id?: number;

  source_name?: TableName;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;

  constructor(o?: Partial<TablePattern>, config?: TableOptions) {
    if (!config) { config = { int: [], date: [] }; }
    if (!config.int) { config.int = []; }
    if (!config.date) { config.date = []; }

    config.int.push('id');
    config.date.push(...['created_at', 'updated_at', 'deleted_at']);

    super(o, config);
  }

}

export class TableNamed extends TablePattern {
  name: string;
  nickname: string;

  constructor(o: Partial<TableNamed>, config?: TableOptions) {
    super(o, config);
  }
}

